
(function () {
"use strict";
var REDUCED_MOTION = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
var LAZY_ROOT_MARGIN = "800px 0px";
function shuffleContainerChildren(container) {
var items = Array.prototype.slice.call(container.children);
for (var i = items.length - 1; i > 0; i--) {
var j = Math.floor(Math.random() * (i + 1));
var tmp = items[i];
items[i] = items[j];
items[j] = tmp;
}
items.forEach(function (el) {
container.appendChild(el);
});
}
function initShuffle(root) {
var containers = (root || document).querySelectorAll('[data-spv-shuffle="true"]');
containers.forEach(function (container) {
if (container.getAttribute("data-spv-shuffled") === "true") return; 
shuffleContainerChildren(container);
container.setAttribute("data-spv-shuffled", "true");
var max = parseInt(container.getAttribute("data-max") || "", 10);
if (max) max = Math.min(max, 10);
if (max) {
Array.prototype.slice.call(container.children).forEach(function (el, i) {
if (i >= max && el.parentNode) el.parentNode.removeChild(el);
});
}
var initialBatch = parseInt(container.getAttribute("data-initial-batch") || "", 10);
if (initialBatch) {
Array.prototype.slice.call(container.children).forEach(function (el, i) {
if (i >= initialBatch) el.setAttribute("hidden", "");
});
}
});
}
function initCarouselAutoplay(root) {
var tracks = (root || document).querySelectorAll('.spv-carousel__track[data-autoplay="true"]');
tracks.forEach(function (track) {
if (track.getAttribute("data-spv-autoplay-ready") === "true") return;
track.setAttribute("data-spv-autoplay-ready", "true");
if (REDUCED_MOTION) return;
if (window.matchMedia && window.matchMedia("(max-width: 749px)").matches) return;
var originalTiles = Array.prototype.slice.call(track.children);
if (originalTiles.length < 2) return; 
originalTiles.forEach(function (tile) {
var clone = tile.cloneNode(true);
clone.setAttribute("aria-hidden", "true");
clone.removeAttribute("id");
clone.removeAttribute("data-spv-open-viewer");
clone.setAttribute("tabindex", "-1");
track.appendChild(clone);
});
var speedSetting = parseFloat(track.getAttribute("data-speed")) || 40;
var duration = Math.max(12, originalTiles.length * (speedSetting / 8));
track.style.setProperty("--spv-carousel-duration", duration + "s");
track.classList.add("spv-carousel__track--auto");
var pause = function () { track.classList.add("spv-carousel--paused"); };
var resume = function () { track.classList.remove("spv-carousel--paused"); };
track.addEventListener("mouseenter", pause);
track.addEventListener("mouseleave", resume);
track.addEventListener("focusin", pause);
track.addEventListener("focusout", resume);
track.addEventListener("touchstart", pause, { passive: true });
});
}
var SPV_IS_MOBILE = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
var MAX_ACTIVE_VIDEOS = SPV_IS_MOBILE ? 2 : 6;
var activeVideoTiles = []; 
function teardownTileVideo(tile) {
var v = tile.__spvVideo;
if (v) {
try { v.pause(); } catch (e) {}
v.removeAttribute("src");
try { v.load(); } catch (e) {} 
if (v.parentNode) v.parentNode.removeChild(v);
}
tile.__spvVideo = null;
tile.setAttribute("data-playing", "false");
var idx = activeVideoTiles.indexOf(tile);
if (idx > -1) activeVideoTiles.splice(idx, 1);
}
function buildTileVideo(tile) {
if (tile.__spvVideo) return tile.__spvVideo;
var src = tile.getAttribute("data-spv-video-src");
if (!src) return null;
var v = document.createElement("video");
v.className = "spv-tile__media";
v.src = src; 
v.loop = true;
v.muted = true;
v.playsInline = true;
v.setAttribute("playsinline", "");
v.preload = "auto";
tile.appendChild(v);
tile.__spvVideo = v;
return v;
}
function activateTileVideo(tile) {
var v = buildTileVideo(tile);
if (!v) return;
var idx = activeVideoTiles.indexOf(tile);
if (idx > -1) activeVideoTiles.splice(idx, 1);
activeVideoTiles.push(tile);
while (activeVideoTiles.length > MAX_ACTIVE_VIDEOS) {
var oldest = activeVideoTiles.shift();
if (oldest !== tile) teardownTileVideo(oldest);
}
if (REDUCED_MOTION) {
if (v.readyState < 2) { try { v.load(); } catch (e) {} } 
return;
}
var p = v.play();
if (p && p.catch) p.catch(function () {});
tile.setAttribute("data-playing", "true");
}
function initTileAutoplay(root) {
var tiles = (root || document).querySelectorAll("[data-spv-tile]");
if (!tiles.length || !("IntersectionObserver" in window)) return;
var observer = new IntersectionObserver(
function (entries) {
entries.forEach(function (entry) {
var tile = entry.target;
if (!tile.getAttribute("data-spv-video-src")) return; 
var shouldPlay = entry.isIntersecting && (!SPV_IS_MOBILE || entry.intersectionRatio >= 0.5);
if (shouldPlay) {
activateTileVideo(tile);
} else {
teardownTileVideo(tile);
}
});
},
{ rootMargin: "0px", threshold: [0, 0.25, 0.5, 0.75, 1] }
);
tiles.forEach(function (tile) {
if (tile.getAttribute("data-spv-bound") === "true") return;
tile.setAttribute("data-spv-bound", "true");
observer.observe(tile);
if (tile.getAttribute("data-spv-open-viewer") === "true") return;
tile.addEventListener("click", function () {
var v = tile.__spvVideo || buildTileVideo(tile);
if (!v) return;
v.muted = !v.muted;
if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
});
});
}
var sharedViewer = null;
function ensureViewerDom() {
var viewer = document.querySelector("[data-spv-viewer]");
if (viewer) return viewer;
viewer = document.createElement("div");
viewer.className = "spv-viewer";
viewer.setAttribute("data-spv-viewer", "");
viewer.setAttribute("data-open", "false");
viewer.setAttribute("role", "dialog");
viewer.setAttribute("aria-modal", "true");
viewer.setAttribute("aria-label", "Creator video");
viewer.innerHTML =
'<div class="spv-viewer__bars" data-spv-viewer-bars></div>' +
'<div class="spv-viewer__header">' +
'<div class="spv-viewer__who"><img data-spv-viewer-avatar src="" alt="" width="28" height="28"><span data-spv-viewer-who></span></div>' +
'<div class="spv-viewer__controls">' +
'<button type="button" data-spv-viewer-mute aria-label="Toggle sound">\uD83D\uDD0A</button>' +
'<button type="button" data-spv-viewer-close aria-label="Close">\u2715</button>' +
"</div>" +
"</div>" +
'<div class="spv-viewer__stage" data-spv-viewer-stage>' +
'<div class="spv-viewer__tap-zone spv-viewer__tap-zone--prev" data-spv-viewer-prev></div>' +
'<div class="spv-viewer__tap-zone spv-viewer__tap-zone--next" data-spv-viewer-next></div>' +
"</div>" +
'<div class="spv-viewer__cta-group" data-spv-viewer-cta></div>';
document.body.appendChild(viewer);
return viewer;
}
function createViewerController() {
var viewer = ensureViewerDom();
var stage = viewer.querySelector("[data-spv-viewer-stage]");
var barsWrap = viewer.querySelector("[data-spv-viewer-bars]");
var whoName = viewer.querySelector("[data-spv-viewer-who]");
var whoAvatar = viewer.querySelector("[data-spv-viewer-avatar]");
var ctaGroup = viewer.querySelector("[data-spv-viewer-cta]");
var closeBtn = viewer.querySelector("[data-spv-viewer-close]");
var muteBtn = viewer.querySelector("[data-spv-viewer-mute]");
var prevZone = viewer.querySelector("[data-spv-viewer-prev]");
var nextZone = viewer.querySelector("[data-spv-viewer-next]");
var items = [];
var currentIndex = 0;
var muted = false; 
var DURATION = 8000;
var rafId = null;
var startTime = null;
function attemptPlay(el) {
var playPromise = el.play();
if (playPromise && playPromise.catch) {
playPromise.catch(function () {
if (!el.muted) {
el.muted = true;
muted = true;
if (muteBtn) muteBtn.textContent = "\uD83D\uDD07";
var retry = el.play();
if (retry && retry.catch) retry.catch(function () {});
}
});
}
}
function render() {
var c = items[currentIndex];
if (!c) return closeViewer();
stage.innerHTML = "";
var el;
if (c.videoUrl) {
el = document.createElement("video");
el.src = c.videoUrl;
if (c.posterUrl) el.poster = c.posterUrl; 
el.muted = muted;
el.playsInline = true;
el.autoplay = true;
el.controls = false;
el.addEventListener("ended", goNext);
el.addEventListener("click", function () {
if (el.paused) attemptPlay(el);
});
} else if (c.posterUrl) {
el = document.createElement("img");
el.src = c.posterUrl;
el.alt = "";
}
if (el) stage.appendChild(el);
if (c.videoUrl && el) attemptPlay(el);
if (whoName) whoName.textContent = c.name || c.handle || "";
if (whoAvatar) whoAvatar.src = c.avatar || c.posterUrl || "";
if (muteBtn) muteBtn.textContent = muted ? "\uD83D\uDD07" : "\uD83D\uDD0A";
if (ctaGroup) {
ctaGroup.innerHTML = "";
if (c.products && c.products.length) {
c.products.slice(0, 4).forEach(function (p) {
if (!p || !p.url) return;
var a = document.createElement("a");
a.className = "spv-viewer__cta";
a.href = p.url;
a.textContent = "Shop " + (p.title || "this product") + " \u2192";
ctaGroup.appendChild(a);
});
ctaGroup.style.display = ctaGroup.children.length ? "flex" : "none";
} else {
ctaGroup.style.display = "none";
}
}
buildBars();
startProgress();
}
function buildBars() {
barsWrap.innerHTML = "";
items.forEach(function (_, i) {
var bar = document.createElement("div");
bar.className = "spv-viewer__bar";
var fill = document.createElement("div");
fill.className = "spv-viewer__bar-fill";
if (i < currentIndex) fill.style.width = "100%";
bar.appendChild(fill);
barsWrap.appendChild(bar);
});
}
function startProgress() {
cancelAnimationFrame(rafId);
startTime = null;
var fill = barsWrap.children[currentIndex] && barsWrap.children[currentIndex].firstChild;
if (!fill) return;
function step(ts) {
if (!startTime) startTime = ts;
var elapsed = ts - startTime;
var pct = Math.min(100, (elapsed / DURATION) * 100);
fill.style.width = pct + "%";
if (pct < 100) {
rafId = requestAnimationFrame(step);
} else {
goNext();
}
}
rafId = requestAnimationFrame(step);
}
function goNext() {
cancelAnimationFrame(rafId);
if (currentIndex < items.length - 1) {
currentIndex++;
render();
} else {
closeViewer();
}
}
function goPrev() {
cancelAnimationFrame(rafId);
if (currentIndex > 0) {
currentIndex--;
render();
}
}
function openViewer(list, startIndex) {
items = list || [];
currentIndex = startIndex || 0;
muted = false;
viewer.setAttribute("data-open", "true");
document.body.style.overflow = "hidden";
render();
}
function closeViewer() {
cancelAnimationFrame(rafId);
viewer.setAttribute("data-open", "false");
stage.innerHTML = "";
document.body.style.overflow = "";
}
if (closeBtn) closeBtn.addEventListener("click", closeViewer);
if (prevZone) prevZone.addEventListener("click", goPrev);
if (nextZone) nextZone.addEventListener("click", goNext);
if (muteBtn) {
muteBtn.addEventListener("click", function () {
muted = !muted;
var video = stage.querySelector("video");
if (video) video.muted = muted;
muteBtn.textContent = muted ? "\uD83D\uDD07" : "\uD83D\uDD0A";
});
}
document.addEventListener("keydown", function (e) {
if (viewer.getAttribute("data-open") !== "true") return;
if (e.key === "Escape") closeViewer();
if (e.key === "ArrowRight") goNext();
if (e.key === "ArrowLeft") goPrev();
});
viewer.addEventListener("click", function (e) {
if (e.target === viewer) closeViewer();
});
return { open: openViewer, close: closeViewer };
}
function getSharedViewer() {
if (!sharedViewer) sharedViewer = createViewerController();
return sharedViewer;
}
function entryFromStoryCircle(circle) {
var products = [];
try {
products = JSON.parse(circle.getAttribute("data-products") || "[]");
} catch (e) {
products = [];
}
return {
name: circle.getAttribute("data-name") || "",
avatar: circle.getAttribute("data-avatar") || "",
handle: circle.getAttribute("data-handle") || "",
videoUrl: circle.getAttribute("data-video-url") || "",
posterUrl: circle.getAttribute("data-poster-url") || "",
products: products,
};
}
function initStoryTriggers(root) {
var circles = (root || document).querySelectorAll("[data-spv-story]");
if (!circles.length) return;
var list = Array.prototype.map.call(circles, entryFromStoryCircle);
circles.forEach(function (circle, i) {
if (circle.getAttribute("data-spv-bound") === "true") return;
circle.setAttribute("data-spv-bound", "true");
circle.addEventListener("click", function () {
getSharedViewer().open(list, i);
});
});
}
function entryFromTile(tile) {
var products = [];
try {
products = JSON.parse(tile.getAttribute("data-products") || "[]");
} catch (e) {
products = [];
}
return {
name: tile.getAttribute("data-name") || "",
avatar: tile.getAttribute("data-poster-url") || "",
handle: tile.getAttribute("data-handle") || "",
videoUrl: tile.getAttribute("data-video-url") || "",
posterUrl: tile.getAttribute("data-poster-url") || "",
products: products,
};
}
function initTileViewerTriggers(root) {
var tiles = (root || document).querySelectorAll('[data-spv-open-viewer="true"]');
if (!tiles.length) return;
var groups = {};
tiles.forEach(function (tile) {
if (tile.getAttribute("aria-hidden") === "true") return; 
var key = tile.getAttribute("data-spv-group") || "default";
(groups[key] = groups[key] || []).push(tile);
});
Object.keys(groups).forEach(function (key) {
var groupTiles = groups[key];
var list = groupTiles.map(entryFromTile);
groupTiles.forEach(function (tile, i) {
if (tile.getAttribute("data-spv-viewer-bound") === "true") return;
tile.setAttribute("data-spv-viewer-bound", "true");
tile.addEventListener("click", function (e) {
e.preventDefault();
getSharedViewer().open(list, i);
});
});
});
}
function initPopup() {
var root = document.querySelector("[data-spv-popup-root]");
if (!root) return;
var mode = root.getAttribute("data-mode");
var frequency = root.getAttribute("data-frequency") || "once-per-session";
var storageKey = "spvPopupDismissed";
function dismiss() {
try { sessionStorage.setItem(storageKey, "1"); } catch (e) {}
}
if (mode === "bubble") {
var bubble = root.querySelector("[data-spv-bubble]");
var card = root.querySelector("[data-spv-card]");
var close = root.querySelector("[data-spv-close]");
if (!bubble || !card) return;
bubble.addEventListener("click", function () {
var isOpen = card.getAttribute("data-open") === "true";
bubble.setAttribute("data-open", isOpen ? "false" : "true");
card.setAttribute("data-open", isOpen ? "false" : "true");
var video = card.querySelector("video");
if (!isOpen && video && !REDUCED_MOTION) {
var p = video.play();
if (p && p.catch) p.catch(function () {});
} else if (isOpen && video) {
video.pause();
}
});
if (close) {
close.addEventListener("click", function (e) {
e.stopPropagation();
card.setAttribute("data-open", "false");
bubble.setAttribute("data-open", "false");
var video = card.querySelector("video");
if (video) video.pause();
});
}
}
if (mode === "toast") {
if (frequency === "once-per-session" && sessionStorage.getItem(storageKey)) {
return;
}
var toast = root.querySelector("[data-spv-toast]");
var toastClose = root.querySelector("[data-spv-toast-close]");
var delaySeconds = parseInt(root.getAttribute("data-delay-seconds") || "4", 10);
var displaySeconds = parseInt(root.getAttribute("data-display-seconds") || "6", 10);
if (!toast) return;
var showTimer = setTimeout(function () {
toast.setAttribute("data-open", "true");
var hideTimer = setTimeout(function () {
toast.setAttribute("data-open", "false");
dismiss();
}, displaySeconds * 1000);
toast.setAttribute("data-hide-timer", hideTimer);
}, delaySeconds * 1000);
if (toastClose) {
toastClose.addEventListener("click", function () {
clearTimeout(showTimer);
toast.setAttribute("data-open", "false");
dismiss();
});
}
}
}
function initLoadMore() {
document.querySelectorAll("[data-spv-loadmore]").forEach(function (button) {
if (button.getAttribute("data-spv-bound") === "true") return;
button.setAttribute("data-spv-bound", "true");
button.addEventListener("click", function () {
var wrapId = button.getAttribute("data-target");
var wrap = document.getElementById(wrapId);
if (!wrap) return;
var hidden = wrap.querySelectorAll("[hidden]");
var batch = parseInt(button.getAttribute("data-batch") || "8", 10);
for (var i = 0; i < hidden.length && i < batch; i++) {
hidden[i].removeAttribute("hidden");
}
initTileAutoplay(wrap);
initTileViewerTriggers(wrap);
if (wrap.querySelectorAll("[hidden]").length === 0) {
button.style.display = "none";
}
});
});
}
function initSectionNow(root) {
initShuffle(root);
initStoryTriggers(root);
initCarouselAutoplay(root);
initTileAutoplay(root);
initTileViewerTriggers(root);
}
function initLazySections() {
var sections = document.querySelectorAll(".spv-scope");
if (!sections.length) return;
if (!("IntersectionObserver" in window)) {
sections.forEach(function (section) {
if (section.getAttribute("data-spv-section-ready") === "true") return;
section.setAttribute("data-spv-section-ready", "true");
initSectionNow(section);
});
return;
}
var sectionObserver = new IntersectionObserver(
function (entries) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
var section = entry.target;
sectionObserver.unobserve(section);
if (section.getAttribute("data-spv-section-ready") === "true") return;
section.setAttribute("data-spv-section-ready", "true");
initSectionNow(section);
});
},
{ rootMargin: LAZY_ROOT_MARGIN }
);
sections.forEach(function (section) {
if (section.getAttribute("data-spv-section-ready") === "true") return;
sectionObserver.observe(section);
});
}
function boot() {
initLazySections();
initPopup();
initLoadMore();
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", boot);
} else {
boot();
}
document.addEventListener("shopify:section:load", function (e) {
if (e.target && e.target.setAttribute) {
e.target.setAttribute("data-spv-section-ready", "true");
}
initSectionNow(e.target);
initPopup();
});
})();
